import { useEffect, useRef } from 'react'

import { connect, mapReadPretty, useField } from '@formily/react'
import { Input } from 'antd'

import { useMergedRef } from '@eastcoal/common/hooks/useMergedRef'

import { generateControlName } from '../../utils/generateControlName'

import { TextAreaProps, TextAreaRef } from './interface'

const autoSize: TextAreaProps['autoSize'] = {
  minRows: 3,
  maxRows: 10
}

const Component = ({ ref, ...restProps }: TextAreaProps) => {
  const field = useField()
  const textareaRef = useRef<TextAreaRef>(null)
  const mergedRef = useMergedRef<TextAreaRef>(textareaRef, ref)

  useEffect(() => {
    const formName =
      textareaRef.current?.resizableTextArea?.textArea.form?.name || ''
    const textareaName = generateControlName({ field, formName })
    if (textareaRef.current?.resizableTextArea) {
      textareaRef.current.resizableTextArea.textArea.name = textareaName
    }
  }, [field])

  return <Input.TextArea ref={mergedRef} autoSize={autoSize} {...restProps} />
}

export const TextArea = connect(
  Component,
  mapReadPretty(Component, {
    disabled: true
  })
)
